import styled from "styled-components";

export const CopyrightText = styled("div")(({ theme }) => ({
  padding: "20px 0",
  textAlign: "center",
}));

export const Separator = styled("div")(({ theme }) => ({
  width: "100%",
  border: `0.5px solid ${theme.palette.white}`,
  opacity: 0.5,
}));

export const DeveloperLink = styled("a")(({ theme }) => ({
  color: "inherit",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));
